/* eslint-disable max-len */
import * as yup from 'yup';

const ERROS = {
  CAMPOS_OBRIGATORIOS: 'O campo é obrigatório',
  EMAIL_INVALIDO: 'E-mail inválido',
  TELEFONE_INVALIDO: 'Número de telefone inválido',
  CEP_INVALIDO: 'CEP inválido',
}

export const step1ValidationSchema = yup.object({
  tipo_unidade_administrativa: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
  nome_secretaria: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
  endereco: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
  endereco_numero: yup.string().nullable(),
  bairro: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
  cep: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS).min(9, ERROS.CEP_INVALIDO).max(9, ERROS.CEP_INVALIDO),
  email: yup.string().nullable().email(ERROS.EMAIL_INVALIDO).required(ERROS.CAMPOS_OBRIGATORIOS),
  telefone: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS).min(14, ERROS.TELEFONE_INVALIDO).max(15, ERROS.TELEFONE_INVALIDO),
  telefone2: yup.string().nullable().min(14, ERROS.TELEFONE_INVALIDO).max(15, ERROS.TELEFONE_INVALIDO),
  nome_responsavel: yup.string().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
  email_responsavel: yup.string().nullable().email(ERROS.EMAIL_INVALIDO).required(ERROS.CAMPOS_OBRIGATORIOS),
})
